// ABOUTME: Repopula o select de conceito quando o aluno é escolhido no autocomplete.
// ABOUTME: A escala de conceitos vem do regimento do aluno, desconhecido no render inicial.

import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";
import { createElement } from "@uenf/layout";

export default class extends Controller {
  static targets = ["select"];
  static values = { url: String };

  async change(e) {
    const alunoId = e.target.value;
    this.selectTarget.innerHTML = '';
    this.selectTarget.appendChild(createElement('option', { value: '' }));
    if (!alunoId) return;

    // O Stimulus invoca a ação num try/catch síncrono, que não alcança a rejeição de um
    // método async: sem este catch, falha de rede vira "Uncaught (in promise)" e o campo
    // fica vazio sem sinal nenhum.
    try {
      const response = await get(`${this.urlValue}?aluno_id=${alunoId}`, {
        responseKind: "json"
      });
      if (!response.ok) throw new Error(`resposta ${response.statusCode}`);

      for (let conceito of await response.json) {
        this.selectTarget.appendChild(
          createElement('option', { value: conceito }, conceito)
        );
      }
    } catch (erro) {
      console.error('Não foi possível carregar os conceitos do aluno:', erro);
      this.selectTarget.appendChild(
        createElement('option', { value: '', disabled: true }, 'Não foi possível carregar os conceitos')
      );
    }
  }
}
